define([
    "jquery",
    "underscore",
    "marionette",
    "videojs"
], function($, _, Marionette) {
    return Marionette.View.extend({
        el: '.video_wrap',

        initialize: function(){
        }
    });
});